import { Button } from "PFComponents/button";
import { Inline, Stack } from "PFComponents/containers";
import { ProfileAvatar } from "PFComponents/profile_avatar/profile_avatar";
import { SuspendedPill } from "PFComponents/suspended_pill";
import { Typography } from "PFComponents/typography";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { RollforwardProfile } from "PFCore/types";
import { Link } from "react-router";

type RollForwardProfileProps = {
  profile: RollforwardProfile;
  mode?: "button" | "link";
  onClick?: () => void;
};

export const RollForwardProfile = ({ profile, mode = "button", onClick }: RollForwardProfileProps) => {
  const suspendedAt = getAttribute(profile, "suspended_at");

  const content = (
    <Stack>
      <Inline alignItems="center" gap="spacingSm">
        <ProfileAvatar profile={profile as any} size={20} />
        <Typography variant="bodyButtons">{profile.name}</Typography>
      </Inline>
      {suspendedAt && <SuspendedPill suspendedAt={suspendedAt} />}
    </Stack>
  );

  if (suspendedAt) {
    return content;
  }

  if (mode === "link") {
    return (
      <Link to={`/profiles/${profile.id}`}>
        <Typography variant="bodyBold" tag="span">
          {content}
        </Typography>
      </Link>
    );
  }

  return (
    <div>
      <Button kind="text" onClick={onClick}>
        {content}
      </Button>
    </div>
  );
};
